import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@mui/material';
import useAlias from '@src/hooks/useAlias';
import { ConfirmType } from '@src/types/Notes';
import { Dispatch, SetStateAction } from 'react';
import FormattedAlias from '../Translations/FormattedAlias';
import notesx from './NotesSx';

interface NotesConfirmDialogProps {
  error: boolean;
  confirmOpen: boolean;
  handleClose: () => void;
  confirmType: ConfirmType | string;
  deviceName: string;
  setError: Dispatch<SetStateAction<boolean>>;
  setConfirmOpen: Dispatch<SetStateAction<boolean>>;
  handleConfirm: () => void;
}

export default function NotesConfirmDialog({
  error,
  confirmOpen,
  handleClose,
  confirmType,
  deviceName,
  setError,
  setConfirmOpen,
  handleConfirm,
}: NotesConfirmDialogProps) {
  const alias = useAlias();
  let confirmText;
  if (confirmType === ConfirmType.CREATE) {
    confirmText = `${alias('Create note for')} ${deviceName}?`;
  } else if (confirmType === ConfirmType.CLEAR) {
    confirmText = `${alias('Are you sure want to remove all notes')}?`;
  } else {
    confirmText = `${alias('Are you sure want to remove this note')}?`;
  }

  return (
    <Dialog open={confirmOpen} onClose={handleClose}>
      <DialogContent>
        {error && (
          <Alert sx={notesx.alert} variant='outlined' severity='error'>
            <FormattedAlias id={'Note unable to be posted'} />.
          </Alert>
        )}
        <DialogContentText>{confirmText}</DialogContentText>
      </DialogContent>
      <DialogActions sx={notesx.dialogActions}>
        <Button
          size='small'
          onClick={() => {
            setError(false);
            setConfirmOpen(false);
          }}
        >
          <FormattedAlias id={'Cancel'} />
        </Button>
        <Button
          size='small'
          onClick={handleConfirm}
          autoFocus
          variant='contained'
        >
          <FormattedAlias id={'Confirm'} />
        </Button>
      </DialogActions>
    </Dialog>
  );
}
